module.exports = __webpack_public_path__ + "static/Coloring-Sheet-1-582294d2c37e3f046b0271c36c1ae01f.pdf";